import { Component, Vue, Watch } from "vue-property-decorator"
import { formatDate } from '@/utils/timeFilter'
import { UserModule } from '@/store/modules/user'
import { setMarketChannel, setMarketChannelById, getMarketChannelById, getMarketChannelType } from '@/api/common'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class NewChannel extends Vue {
    // ------ data ------
    channelType: number | null = null
    channelTypeList = []
    channelName = ""
    launchStartTime = ""
    remark = ""
    newChannelTime = formatDate('yyyy-MM-dd', new Date())
    marketDutyUserId = ""
    channelId = 0
    newChannelUserName = ""
    confirmButtonDisabled = false
    formModel = {
        channelType: '',
        channelName: '',
        launchStartTime: '',
    }
    marketDutyUserName = '' //负责人
    rules = {
        channelType: [
            {required: true, message: '请选择渠道类型', trigger: 'change'},
        ],
        channelName: [
            {required: true, message: '请输入渠道名称', trigger: 'blur'},
        ],
        launchStartTime: [
            {required: true, message: '请输入投放开始时间', trigger: 'blur'},
        ],

    }
    loading = false


    // ------ computed ------
    get GETnewChannelUserName() {
        return UserModule.userName
    }
    get UserId() {
        return UserModule.userId
    }


    // ------ mounted ------
    mounted() {
        this.getdata()
        if(this.$route.query.id) {
            this.channelId = Number(this.$route.query.id ? this.$route.query.id : '')
            this.getChannelInfo()
        }
    }

    // ------ methods ------
    cancel() {
        window.close()
    }
    confirm() {
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if(valid) {
                // if(!this.formModel.channelType) { this.$message.error('渠道类型不能为空'); return }
                // if(!this.formModel.channelName) { this.$message.error('渠道名称不能为空'); return }
                if(!this.marketDutyUserId) { this.$message.error('负责人不能为空'); return }
                // if(!this.formModel.launchStartTime) { this.$message.error('投放开始时间不能为空'); return }
                if(this.channelId) {
                    this.setMarketChannelById()
                }  else {
                    this.setMarketChannel()
                }
            }
        })
    }
    setMarketChannel() {
        this.confirmButtonDisabled = true
        this.loading = true
        setMarketChannel({
            name: this.formModel.channelName,
            typeId: Number(this.formModel.channelType),
            userId: this.marketDutyUserId,
            beginAt: formatDate('yyyy-MM-dd hh:mm:ss', new Date(this.formModel.launchStartTime)),
        }).then(() => {
            this.$message.success('创建渠道成功，本页面即将关闭')
            this.loading = false
            setTimeout(()=>{
                window.close()
            },1000)
        }).catch(() => {
            this.loading=  false
            this.confirmButtonDisabled = false
        })

    }
    async setMarketChannelById() {
        this.loading = true
        await setMarketChannelById({
            name: this.formModel.channelName,
            typeId: Number(this.formModel.channelType),
            userId: this.marketDutyUserId,
            beginAt: formatDate('yyyy-MM-dd hh:mm:ss', new Date(this.formModel.launchStartTime)),
            remark: this.remark,
            id: this.channelId
        }).then(()=>{
        this.confirmButtonDisabled = true
        this.$message.success('修改渠道成功，本页面即将关闭')
        this.loading = false
        setTimeout(()=>{
            window.close()
        },1000)
        }).catch(err=>{
            this.loading = false
        })
    }
    async getChannelInfo() {
        const data: any = await getMarketChannelById(this.channelId)
        const { beginAt, createUserRealName, createdAt, directorUserRealName, directorUserId,marketChannelTypeName, remark, name } = data.marketChannel
        this.formModel.channelName = name
        this.formModel.launchStartTime = beginAt
        this.remark = remark
        this.newChannelUserName = createUserRealName
        this.newChannelTime = formatDate('yyyy-MM-dd', new Date(createdAt))
        this.formModel.channelType = (this.channelTypeList.filter((item: any)=> item.name == marketChannelTypeName))[0]['id']
        // this.marketDutyUserId = (this.marketDutyUserList.filter((item: any)=> item.realName == directorUserRealName))[0]['id']
        this.marketDutyUserId = directorUserId
        this.marketDutyUserName = directorUserRealName
    }
    async getdata() {
        const data: any = await getMarketChannelType()
        this.channelTypeList = data.marketChannelTypeList
    }

    changemarketDutyUserId(e){
        this.marketDutyUserId = e.id
    }

    // ------ watch ------
    @Watch('UserId')
    watchUserID(val: string) {
        if (!this.marketDutyUserId) {
            this.marketDutyUserId = val
        }
    }
    @Watch('GETnewChannelUserName')
    watchUserName(val: string) {
        if (!this.marketDutyUserName) {
            this.marketDutyUserName = val
        }
    }

}
